/** Cores de status e seleção do talhão no mapa Cadastros. */

export const COLOR_VINCULADO = "#009157";
export const COLOR_DISPONIVEL = "#CECECE";
export const COLOR_TRANSPARENTE = "#00000000";
export const SELECTED_STROKE = "#FF0000";
/** Espessura da borda do talhão selecionado. */
export const SELECTED_STROKE_WEIGHT = 2;
/** Garante que a borda vermelha fique acima das bordas dos vizinhos. */
export const SELECTED_Z_INDEX = 1000;

/** Proporção de vermelho no blend da seleção (0–1). */
export const SELECTED_RED_BLEND = 0.2;

function hexToRgb(hex: string): { r: number; g: number; b: number } | null {
  const normalized = hex.replace("#", "");
  if (normalized.length !== 6) return null;
  const r = parseInt(normalized.slice(0, 2), 16);
  const g = parseInt(normalized.slice(2, 4), 16);
  const b = parseInt(normalized.slice(4, 6), 16);
  if ([r, g, b].some((n) => Number.isNaN(n))) return null;
  return { r, g, b };
}

export function blendHex(baseHex: string, overlayHex: string, t: number): string {
  const base = hexToRgb(baseHex);
  const overlay = hexToRgb(overlayHex);
  if (!base || !overlay) return baseHex;

  const r = Math.round(base.r * (1 - t) + overlay.r * t);
  const g = Math.round(base.g * (1 - t) + overlay.g * t);
  const b = Math.round(base.b * (1 - t) + overlay.b * t);

  return `#${[r, g, b].map((n) => n.toString(16).padStart(2, "0")).join("")}`;
}

export function getSelectedFillColor(statusColor: string): string {
  return blendHex(statusColor, SELECTED_STROKE, SELECTED_RED_BLEND);
}

export const LEGEND_SELECIONADO_FILL = getSelectedFillColor(COLOR_VINCULADO);
